import { useEffect, useReducer, useState } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";
import { WorkItemStatus } from "models/work-items/IMyWorkItem";

type GetWorkItemsResult = {
    totalItems: number,
};

type WorkItemsResult = [
    number,
    boolean,
    string | null,
    () => void
];

const useWorkItemsCount: (status: WorkItemStatus, all?: boolean, run?: boolean) => WorkItemsResult = (status, all, run = true) => {
    const [ total, setTotal ] = useState<number>(0);
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(true);    
    const [ refresh, forceRefresh ] = useReducer(v => v + 1, 0);
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {        
        if (!run) {
            return;
        }
        const controller = new AbortController();
        const fetchWorkItemsCount = async () => {
            const query = `${status}/count`;
            var params = new URLSearchParams;
            if (all) {
                params.append('all', all.toString());
            }

            if (user && user.id_token ) {
                setLoading(true);
                try {

                    
                    const resp = await fetcher(`/api/v3/workitems/${query}?${params}`, {
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const data = await resp.json() as GetWorkItemsResult;
                    if (data.totalItems !== total) {
                        setTotal(data.totalItems);
                    }
                } catch (err) {
                    // Will be done in BFLY-8658 or BFLY-9022
                } finally {
                    if (!controller.signal.aborted)
                        setLoading(false);
                }
            }
        };
        
        fetchWorkItemsCount();
        return () => controller.abort();
    }, [user, status, refresh]);

    return [
        total,
        loading,
        error,
        forceRefresh
    ];
};

export default useWorkItemsCount;